// src/pages/EmailManagementPage.jsx
import React, { useState } from "react";

function EmailManagementPage() {
    const [emails, setEmails] = useState([
        {
            id: 1,
            title: "Welcome Email",
            recipients: "All new users",
            schedule: "Every Monday 9 AM",
            status: "active",
        },
        {
            id: 2,
            title: "Promotion A",
            recipients: "Subscribers only",
            schedule: "2025-01-10 10:00",
            status: "scheduled",
        },
    ]);

    const [formData, setFormData] = useState({
        title: "",
        recipients: "",
        schedule: "",
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        // Example: push the new schedule to your backend, or store in state
        const newEmail = {
            id: emails.length + 1,
            title: formData.title,
            recipients: formData.recipients,
            schedule: formData.schedule,
            status: "scheduled",
        };
        setEmails([...emails, newEmail]);
        setFormData({ title: "", recipients: "", schedule: "" });
    };

    return (
        <div>
            <h1 className="text-2xl font-bold mb-4">Email Management</h1>

            <div className="mb-6 bg-white p-4 rounded shadow">
                <h2 className="text-xl font-semibold mb-2">
                    Schedule a New Email
                </h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block font-medium">
                            Email Title:
                        </label>
                        <input
                            type="text"
                            className="border rounded px-2 py-1 w-full"
                            value={formData.title}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    title: e.target.value,
                                }))
                            }
                        />
                    </div>
                    <div>
                        <label className="block font-medium">Recipients:</label>
                        <input
                            type="text"
                            className="border rounded px-2 py-1 w-full"
                            value={formData.recipients}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    recipients: e.target.value,
                                }))
                            }
                        />
                    </div>
                    <div>
                        <label className="block font-medium">
                            Schedule Time / Interval:
                        </label>
                        <input
                            type="text"
                            className="border rounded px-2 py-1 w-full"
                            placeholder="e.g. Every Monday 9 AM or 2025-01-10 10:00"
                            value={formData.schedule}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    schedule: e.target.value,
                                }))
                            }
                        />
                    </div>
                    <button
                        type="submit"
                        className="bg-blue-500 text-white px-4 py-2 rounded">
                        Schedule Email
                    </button>
                </form>
            </div>

            {/* List of scheduled / active emails */}
            <div className="bg-white p-4 rounded shadow">
                <h2 className="text-xl font-semibold mb-2">
                    Existing Email Schedules
                </h2>
                <table className="w-full">
                    <thead>
                        <tr className="border-b">
                            <th className="p-2 text-left">ID</th>
                            <th className="p-2 text-left">Title</th>
                            <th className="p-2 text-left">Recipients</th>
                            <th className="p-2 text-left">Schedule</th>
                            <th className="p-2 text-left">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {emails.map((email) => (
                            <tr
                                key={email.id}
                                className="border-b hover:bg-gray-50">
                                <td className="p-2">{email.id}</td>
                                <td className="p-2">{email.title}</td>
                                <td className="p-2">{email.recipients}</td>
                                <td className="p-2">{email.schedule}</td>
                                <td className="p-2">{email.status}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default EmailManagementPage;
